import React from 'react';
import { Icon } from './Icon.js';
export const IconLayoutRightFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m9.25,1H2.75C1.233,1,0,2.233,0,3.75v4.5c0,1.517,1.233,2.75,2.75,2.75h6.5c1.517,0,2.75-1.233,2.75-2.75V3.75c0-1.517-1.233-2.75-2.75-2.75Zm.25,6.75c0,.414-.336.75-.75.75s-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconLayoutRightFill12.js.map